import React, { useCallback, useContext, useState, memo } from "react";
import AlbumsList from "../Components/Albums/AlbumsList";
import { useModal } from "../custom-hooks";
import { AlbumsWrapper } from "./Albums.styled";
import Modal from "../Components/Modal";
import "../Components/Albums/Albums.css";
import { Alert } from "rsuite";
import { database } from "../config";
import { ProfileContext } from "../context/profile.context";
import firebase from "firebase";
import MainPageLayout from "../Components/MainPageLayout";

function Albums() {
  const { isOpen, close, open } = useModal();
  const [albumName, setAlbumName] = useState();
  const { profiles } = useContext(ProfileContext);

  const handleInputChange = useCallback((e) => {
    setAlbumName(e.target.value);
  }, []);

  const handleAlbumCancel = useCallback(() => {
    setAlbumName("");
    close();
  }, [close]);

  console.log("render Albums");
  const handleAlbumCreate = useCallback(async () => {
    if (profiles) {
      try {
        await database.ref(`/profiles/${profiles.uid}/albums/`).push().set({
          name: albumName,
          uploadedAt: firebase.database.ServerValue.TIMESTAMP,
        });
        Alert.success("Album Created");
        setAlbumName("");
        close();
      } catch (error) {
        setAlbumName("");
        close();
        Alert.error(error.message);
      }
    }
  }, [albumName, profiles, close]);

  return (
    <MainPageLayout>
      {isOpen && (
        <Modal close={close}>
          <div className="createAlbumDialog">
            <header>Create Album</header>
            <label htmlFor="albumName"></label>
            <input
              type="text"
              id="albumName"
              onChange={handleInputChange}
              placeholder="Album title"
              value={albumName}
            />
            <div className="createAlbumBtn">
              <button className="cancelBtn" onClick={handleAlbumCancel}>
                Cancel
              </button>
              <button className="createBtn" onClick={handleAlbumCreate}>
                Create
              </button>
            </div>
          </div>
        </Modal>
      )}

      <AlbumsWrapper>
        <div className="createAlbumWrapper">
          <button className="createAlbumBtn" onClick={() => open()}>
            +
          </button>

          <h6>Create New Album</h6>
        </div>
        <AlbumsList />
      </AlbumsWrapper>
    </MainPageLayout>
  );
}

export default memo(Albums);
